<template>
  <!--      个人控制台header-->
  <div :class="{ 'console-header': true}">
    <div class="con-box">
      <div class="account">
        <div class="flex-b nw">
          <!-- <p style="margin-right: 20px; font-weight: bold; font-size: 16px">控制台</p> -->
          <img
            class="photo"
            :src="
                authUser.imgPath && !isInDingTalk
                  ? fileOperShow(authUser.imgPath)
                  : '/images/web/login_user_icon.png'
              "
            onerror="this.src='/images/web/login_user_icon.png'"
          />
          <div class="moreInfo">
            <img
              style="width: 20px; height: 20px; margin-right: 5px;"
              v-if="authUser.userStemFrom === -16 && !isInDingTalk"
              src="/images/icon/dingIcon.png"
              alt=""
            />
            <span class="name">
                {{ corpName }}
            </span>
            <!--<i v-if="showExpand" class="el-icon-arrow-right"></i>-->
            <!-- <span v-if="showExpand" style="font-size: 14px; cursor: pointer"><i class="icon-qh"></i>&nbsp;&nbsp;切换</span> -->
          </div>
          <i v-if="!isInDingTalk" class="el-icon-caret-bottom" style="font-size: 24px;"></i>
        </div>
        <div class="comp-expand" v-if="!isInDingTalk">
          <userChange
            @showExpandIcon="showExpandIcon"
            :users="consoleUsers"
            :ywtAccountChoose="true"
          />
        </div>
      </div>
      <div style="display: flex; justify-content: flex-end">
        <div class="ls-sh">
          <el-button class="backBZ" @click="turnBack">返回首页</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { isInDingTalk } from "../../assets/js/utils/ding-env";
  import { fileOperShow, logout } from "../../assets/js/http-serve/http-methods";
  import { consoleMenus } from "../../layouts/js/entConsoleDate";
  import {gantConf} from "../../assets/js/utils/jurisdiction";
  import {setCurrentUser} from "../../assets/js/http-serve/corp/common";
  import userChange from "@/components/change-account/user-change";
    export default {
        name: "userConsoleHeader",
      components: {
        userChange,
      },
      data() {
          return {
            isInDingTalk,
            consoleMenus,
            fileOperShow: fileOperShow,
            showExpand: false,
          }
      },
      computed: {
        corpName () {
          return this.$store.getters.authUser.name || "";
        },
        currentAuthUser () {
          return this.$store.getters.currentAuthUser || {};
        },
        authUser () {
          return this.$store.getters.authUser || {};
        },
        // 获取拥有控制台权限的用户
        consoleUsers () {
          try {
            let users = this.$store.getters.allAuthUser.bindCorpUsers;
            let consoleUsers = [];
            // console.log(this.$store.getters.allAuthUser);
            if (this.$store.getters.allAuthUser.corpCreateFlag === 1) {
              // 超级管理员
              consoleUsers.push(this.$store.getters.allAuthUser.manCorpUser);
            }
            users.forEach(user => {
              if (user.perms && user.perms.length > 0) {
                consoleUsers.push(user);
              }
            });
            return consoleUsers;
          } catch (e) {
            return [];
          }
        },
      },
      methods: {
        turnBack () {
          this.toIndex()
        },
        toIndex () {
          this.$router.push({ path: "/viewIndex" })
          setTimeout(() => {
            setCurrentUser(this.$store.getters.allAuthUser.accountInfoVO);
          }, 500);

        },
        /**
         *  根据页面url 找到对应应该激活的一级菜单
         * */
        getMenu (item) {
          let path = this.$route.path;
          // 递归查找当前菜单及其子集是否包含当前页面路径
          let fd = function (cuIt) {
            const samePath = cuIt.path.indexOf(path) > -1;
            if (samePath) {
              return true;
            } else {
              if (cuIt.children && cuIt.children.length) {
                for (let i = 0; i < cuIt.children.length; i++) {
                  if (fd(cuIt.children[i])) {
                    return true;
                  }
                }
                return false;
              } else {
                return false;
              }
            }
          };
          return fd(item);
        },
        showExpandIcon () {
          this.showExpand = true;
        },
        /** 移除某项菜单 */
        delMenusItem (pid) {
          for (let i = 0; i < consoleMenus.length; i++) {
            const elem = consoleMenus[i];
            if (elem.pid === pid) consoleMenus.splice(i, 1)
          }
        },
        /** 根据账号类型添加菜单项 */
        menusByType () {
          const {perms:storePerms} = this.$store.getters.consoleToken || {};
          const perms = [...(storePerms ? storePerms : [])], current = this.$store.getters.currentAuthUser, binds = this.$store.getters.allAuthUser.bindCorpUsers;
          const bindCorpIds = binds.map(bind => bind.corpUserId)
          let consumptionAuth = perms.includes(gantConf.consumption);
          const isCorp = bindCorpIds.includes(current.corpUserId);
          if (isCorp) {
            const have = consoleMenus.some(item => item.pid === gantConf.consumption)
            if (!have) {
              this.delMenusItem(-1)
              consoleMenus.push({
                pid: gantConf.consumption,
                name: '企业消费统计',
                path: "/console/account",
                tip: ""
              });
            }
          }
          if (!isCorp) {
            const have = consoleMenus.some(item => item.pid === -1)
            if (!have) {
              this.delMenusItem(gantConf.consumption)
              consoleMenus.push({
                pid: -1, //不需要权限
                name: "企业账户中心",
                path: "/console/account?type=2",
                tip: ""
              });
            }

          }
        },
      },
      mounted(){
      let width = document.getElementsByClassName('console-header')[0].clientWidth
      console.log('width',width);
      }
    }
</script>

<style scoped lang="less">
@import url('../../assets/style/cssVariable.less');
@media (max-width: 1366px) {
  .console-header {
    // 个人控制台显示姓名
    // .moreInfo{
    //   display: none !important;
    // }
  }
  .con-box{
    width: 100% !important;
  }
}
  .console-header {
    width: 100%;
    height: 60px;
    line-height: 60px;
    /*background: rgba(41, 2, 2, 1);*/
    background: #ec1c1c;
    font-size: 14px;
    font-family: Source Han Sans SC;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10;
    .moreInfo{
      display: flex;
      align-items: center;
    }

    &.nbd {
      background: rgba(255, 255, 255, 0.1);
    }

    ul {
      list-style: none;
      display: inline-block;
      margin-right: 20px;
    }

    li {
      cursor: pointer;
      float: left;
      list-style: none;
      text-align: center;
      width: 110px;
      height: 60px;

      a {
        display: block;
        color: rgba(255, 255, 255, 1);
        text-decoration: none;
      }

      &:hover {
        background: rgba(255, 255, 255, 0.31);
      }

      &.active {
        background: rgba(255, 255, 255, 0.31);
      }
    }

    .account {
      z-index: 1;
      position: relative;

      .nw {
        position: relative;
        z-index: 6;
      }

      .photo {
        width: 25px;
        height: 25px;
        margin-right: 5px;
        border-radius: 50%;
      }

      .name {
        display: inline-block;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        /*min-width: 130px;*/
        /*max-width: 150px;*/
        max-width: 220px;
        min-width: 60px;
        margin-right: 3px;
        cursor: pointer;
      }

      .comp-expand {
        width: 0;
        height: 0;
        box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.16);
        position: absolute;
        z-index: -1;
        top: 56px;
        left: 2px;
        background-color: #ffffff;
        transform: translateY(-100%);
        /*transition: all .3s;*/
        opacity: 0;
        color: #000000;
        border-radius: 5px;
        overflow: hidden;
        /*width: 130%;*/
        transition-property: opacity, top, transform;
        transition-duration: 0.2s, 0.2s, 0.2s;
        transition-timing-function: ease;

        /deep/ .change-account {
          li {
            border-bottom: solid 1px #ddd;
            .current-user {
              right: 15px;
            }
          }

          .search-profile {
            position: absolute;
            background-color: #ffffff;
            padding: 0 20px;
            border-bottom: solid 1px #ddd;
          }

          .wrap {
            overflow-y: auto;
            max-height: 420px;
          }
        }
      }

      &:hover {
        .el-icon-arrow-right {
          transform: rotate(90deg);
        }

        .comp-expand {
          height: auto;
          min-width: 300px;
          /*z-index: 2;*/
          transform: translateY(0);
          opacity: 1;
        }
      }
    }
  }

  .flex-b {
    display: flex;
    justify-content: space-between;
    align-items: center;
    &:hover{
    .el-icon-caret-bottom{
      transform: rotate(180deg);
    }
  }
  }

  .con-box {
    width: 1366px;
    height: 100%;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    padding: 0 20px;
  }

  .ls-sh {
    height: 100%;
    display: inline-block;
    position: relative;

    img {
      display: inline-block;
      width: 25px;
      height: 25px;
      margin-right: 5px;
      border-radius: 50%;
    }

    .icon {
      cursor: pointer;
      margin-left: 30px;
    }
  }
  .icon-qh {
    width: 16px;
    height: 16px;
    display: inline-block;
    background: url("/images/icon-qh.png") no-repeat;
    background-size: 100% 100%;
    margin-left: 10px;
  }
  .backBZ {
    font-size: 14px;
    font-family: Source Han Sans SC;
    font-weight: 400;
    color: @ebq-red;
    padding: 7px 10px;
    border-radius: 4px;

    &:hover {
      background: @ebq-bg-turn;
    }
  }
</style>



// WEBPACK FOOTER //
// components/header/userConsoleHeader.vue